/** Group Node Expand Collapse Action Type*/
export enum GroupNodeExpandCollapse {
  Expand = 'Expand',
  Collapse = 'Collapse',
}
